import Axios from "@app/api/axios";
import { PRODUCTS } from "@utils/constant";

const getDataSources = () => {
  return Axios.get(`${PRODUCTS}/data_sources`);
};

export default getDataSources;
